export default "__VITE_ASSET__FZ035_gn__"